import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import MobileRestriction from '../components/MobileRestriction'; 
import { useDeviceRestriction } from '../hooks/useDeviceRestriction'; 
import { useAuth } from '../context/AuthContext'; // ✅ TAMBAHKAN IMPORT INI
import '../style/MainLayout.css';

const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { currentUser } = useAuth(); // ✅ SEKARANG SUDAH TERDEFINISI
  // const mobileRestriction = useDeviceRestriction(); // Dikomentari untuk history

  // Effect untuk mendeteksi resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // Auto close sidebar when switching from mobile to desktop
      if (!mobile && sidebarOpen) {
        setSidebarOpen(false);
      }
      
      // Reset body overflow when switching to desktop
      if (!mobile) {
        document.body.style.overflow = 'unset';
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      // Cleanup on unmount
      document.body.style.overflow = 'unset';
    };
  }, [sidebarOpen]);

  // Effect untuk mengontrol scroll body saat sidebar mobile terbuka
  useEffect(() => {
    if (isMobile) {
      if (sidebarOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }
    }
  }, [sidebarOpen, isMobile]);

  // Effect untuk mengirim state sidebar ke komponen lain
  useEffect(() => {
    // Dispatch event untuk memberi tahu komponen lain tentang perubahan sidebar
    window.dispatchEvent(new CustomEvent('sidebarStateChange', { 
      detail: { isOpen: sidebarOpen, isCollapsed: sidebarCollapsed } 
    }));
  }, [sidebarOpen, sidebarCollapsed]);

  const toggleSidebar = () => {
    if (isMobile) {
      setSidebarOpen(!sidebarOpen);
    } else {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  const handleCloseSidebar = () => {
    setSidebarOpen(false);
  };

  // Handle click on main content to close sidebar on mobile
  const handleMainContentClick = () => {
    if (isMobile && sidebarOpen) {
      setSidebarOpen(false);
    }
  };

  // Original mobile restriction check (dikomentari untuk history)
  /*
  // Jika device mobile, tampilkan restriction
  if (isMobile) {
    return <MobileRestriction />;
  }
  */

  // Jika desktop, tampilkan layout normal
  return (
    <div className="main-layout">
      {/* Overlay for mobile */}
      {isMobile && sidebarOpen && (
        <div 
          className="sidebar-overlay" 
          onClick={handleCloseSidebar}
          aria-hidden="true"
        />
      )}
      
      <Sidebar 
        isOpen={sidebarOpen}
        isCollapsed={sidebarCollapsed}
        onClose={handleCloseSidebar}
      />
      
      <div 
        className={`main-content ${!sidebarCollapsed && !isMobile ? 'expanded' : ''}`}
        onClick={handleMainContentClick}
      >
        <Header toggleSidebar={toggleSidebar} />
        <main className="page-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;